import React, { useState } from 'react'
import { graphql, Link} from 'gatsby'
import { RichText} from 'prismic-reactjs'
import Layout from '@layout'
import SEO from '@layout/SEO'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import './styles.css'

export const faqPageData = graphql `
query 
{  
   allPrismicFaqs {
    edges {
      node {
        data {
           faq_items {
            question
            answer {
              direction
              text
              type
              spans {
                  data {
                  url
                  target
                  link_type
                }
                end
                start
                type
              }
            }
            question_category
        }
      }
    }
  }
}
}
`


const FAQ = (props) => {
    console.log('Props:', props);
    console.log('Data:', props.data);
    const faqData = props.data;
    const allPrismicFaqsStuff = faqData.allPrismicFaqs.edges[0];
    console.log('Edges:', allPrismicFaqsStuff);
    console.log('This:', allPrismicFaqsStuff.node.data);

    const [openIndexes, setOpenIndexes] = useState([]);
    const toggleFaq = (index) => {
      if (openIndexes.includes(index)) {
        setOpenIndexes(openIndexes.filter(i => i !== index));
      } else {
      setOpenIndexes([...openIndexes,index]);
      }
    };

    const faqPageInfo = props.data.allPrismicFaqs.edges[0].node.data;
    const groupedFaqs = faqPageInfo.faq_items.reduce((cat, item) => {
      const category = item.question_category || 'Uncategorized';
      if(!cat[category]) {
        cat[category] = [];
      }
      cat[category].push(item)
      return cat;
    }, {});

    let globalIndex = 0;

    // const staffLeftColumn = aboutPageInfo.staff_group.filter(group => group.display_column === "Left").sort((g1, g2) => g1.display_order - g2.display_order);
    // const staffRightColumn = aboutPageInfo.staff_group.filter(group => group.display_column === "Right").sort((g1, g2) => g1.display_order - g2.display_order);
    if (typeof window !== "undefined"){
        return (
        <Layout>
            <SEO title="About the Constituent Services Unit" description="General information about the Constituent Services Unit of Research Division" pathname={props.location.pathname}/>
            <Row>
                <Col lg={9} className="text-left">
                    <h1>Frequently Asked Questions</h1> 
                </Col>
                <Col lg={3} className="text-lg-right pr-lg-3 pt-2 pt-lg-0">
                  <div className="top-links">
                    <p className="h5 font-weight-bold">Other Options</p>
                    <p className="h6">
                        <a className="animated" href="/Division/Research/Content/">Browse our Featured Content</a>
                    </p>
                    <p className="h6">
                        <Link className="animated" to="/Contact">Contact Us</Link>
                    </p>
                  </div>
                </Col>
            </Row>
            <hr className="my-4"/> 
          <Row>
                <Col className="text-left">
                  {Object.entries(groupedFaqs).map(([category,items]) =>(
                    <div className='category-section'>
                      <h3 className='category-heading'>{category}</h3>                 
                      {items.map((item) => {
                        const currentIndex = globalIndex++;
                        return (
                          <div key={currentIndex} className="faq-item">
                            <div className='faq-question'
                              onClick={() => toggleFaq(currentIndex)}>
                              <span
                                className="arrow"
                                style={{
                                  marginRight: '10px',
                                  transition: 'transform 0.3s',
                                  transform: openIndexes.includes(currentIndex) ? 'rotate(180deg)' : 'rotate(0deg)'
                                }}
                              >
                                &#9660;
                              </span>
                              <span className='faq-question-text'><strong>{item.question}</strong></span> 
                            </div>

                          <div className={`faq-answer${openIndexes.includes(currentIndex) ? ' faq-answer--open' : ''}`}>
                              <div className='faq-answer-inner'>
                                {item.answer.map((ans,indexA) => (
                                  <div key={indexA}>
                                    <RichText render={[ans]}/>
                                  </div>
                                ))}
                              </div>
                            </div>   
                            
                          </div>
                        );
                      }  
                      )}
                    </div>
                ))}
              </Col>
            </Row>

        </Layout>
    )
    }
    else {
        return null
    }
        
}

export default FAQ